module.exports = __webpack_public_path__ + "img/snorkeling-8.3ee5aa78.jpeg";